import { useMemo } from 'react';

import useEvents from 'hooks/useEvents';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

const EventProvider: FunctionComponent<Props> = ({ children, eventPrefix, testId = TEST_ID }) => {
    const { context } = useEvents();

    const value = useMemo(() => ({ eventPrefix }), [eventPrefix]);

    return (
        <context.Provider data-testid={testId} value={value}>
            {children}
        </context.Provider>
    );
};

EventProvider.displayName = 'EventProvider';

export default EventProvider;
